
import Vue, { PropType } from 'vue'
import { Alert } from '@/models'

import AlertListHeader from './AlertListHeader.vue'
import AlertListItem from './AlertListItem.vue'

export default Vue.extend({
  name: 'AlertList',

  props: {
    alerts: Array as PropType<Array<Alert>>,
  },

  components: {
    AlertListHeader,
    AlertListItem
  },
})
